/* ============================================================
   MEGA MENU — Click & keyboard support
   ============================================================ */
(function () {
  'use strict';

  var navItems = document.querySelectorAll('.menu__item--has-megamenu');
  if (!navItems.length) return;

  function closeAll(exceptItem) {
    navItems.forEach(function (item) {
      if (exceptItem && item === exceptItem) return;

      item.classList.remove('is-open');

      var trigger = item.querySelector('[data-megamenu-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  navItems.forEach(function (item) {
    var trigger = item.querySelector('[data-megamenu-trigger]');
    var dropdown = item.querySelector('[data-megamenu], [data-flyout]');

    if (!trigger || !dropdown) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();

      var isOpen = item.classList.contains('is-open');

      closeAll(item);

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        var isOpen = item.classList.contains('is-open');

        closeAll(item);

        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      }

      if (e.key === 'Escape') {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });

  document.addEventListener('click', function (e) {
    var clickedInsideMenu = e.target.closest('.menu__item--has-megamenu');

    if (!clickedInsideMenu) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
    }
  });
})();